import { createAction, props } from '@ngrx/store';
import { HealthyWorkplaceSurveyManagementDTO } from '@iota/inh-core-v1-management-client';

export enum HwpActionTypes {
    LoadSurveys = '[Hwp] Load Surveys',
    LoadSurveysSuccess = '[Hwp] Load Surveys Success',
    LoadSurveysFailure = '[Hwp] Load Surveys Failure',

    LoadSurvey = '[Hwp] Load Survey',
    LoadSurveySuccess = '[Hwp] Load Survey Success',
    LoadSurveyFailure = '[Hwp] Load Survey Failure',

    UpdateSurvey = '[Hwp] Update HWP Survey',

    GenerateProjectSetup = '[Hwp] Generate Project Setup',
    GenerateProjectSetupSuccess = '[Hwp] Generate Project Setup Success',
    GenerateProjectSetupFailure = '[Hwp] Generate Project Setup Failure',

    ApproveSurvey = '[Hwp] Approve Survey',
    ApproveSurveySuccess = '[Hwp] Approve Survey Success',
    ApproveSurveyFailure = '[Hwp] Approve Survey Failure',

    RejectSurvey = '[Hwp] Reject Survey',
    RejectSurveySuccess = '[Hwp] Reject Survey Success',
    RejectSurveyFailure = '[Hwp] Reject Survey Failure',

    AddSurveyUrl = '[Hwp] Add Survey URL',
    AddSurveyUrlSuccess = '[Hwp] Add Survey URL Success',
    AddSurveyUrlFailure = '[Hwp] Add Survey URL Failure',

    CompleteSurvey = '[Hwp] Complete Survey',
    CompleteSurveySuccess = '[Hwp] Complete Survey Success',
    CompleteSurveyFailure = '[Hwp] Complete Survey Failure',

    LoadSurveyDescription = '[Hwp] Load Survey Description',
    LoadSurveyDescriptionSuccess = '[Hwp] Load Survey Description Success',
    LoadSurveyDescriptionFailure = '[Hwp] Load Survey Description Failure'
}

export const LoadSurveys = createAction(HwpActionTypes.LoadSurveys);
export const LoadSurveysSuccess = createAction(
    HwpActionTypes.LoadSurveysSuccess,
    props<{ surveys: HealthyWorkplaceSurveyManagementDTO[] }>()
);
export const LoadSurveysFailure = createAction(HwpActionTypes.LoadSurveysFailure, props<{ error: any }>());

export const LoadSurvey = createAction(HwpActionTypes.LoadSurvey, props<{ surveyId: string }>());
export const LoadSurveySuccess = createAction(
    HwpActionTypes.LoadSurveySuccess,
    props<{
        survey: HealthyWorkplaceSurveyManagementDTO;
    }>()
);
export const LoadSurveyFailure = createAction(HwpActionTypes.LoadSurveyFailure, props<{ error: any }>());

export const UpdateSurvey = createAction(
    HwpActionTypes.UpdateSurvey,
    props<{ surveyId: string; newState: HealthyWorkplaceSurveyManagementDTO.StatusEnum }>()
);

export const GenerateProjectSetup = createAction(HwpActionTypes.GenerateProjectSetup, props<{ surveyId: string }>());
export const GenerateProjectSetupSuccess = createAction(
    HwpActionTypes.GenerateProjectSetupSuccess,
    props<{
        projectSetup: string[];
    }>()
);
export const GenerateProjectSetupFailure = createAction(
    HwpActionTypes.GenerateProjectSetupFailure,
    props<{
        error: any;
    }>()
);

export const ApproveSurvey = createAction(HwpActionTypes.ApproveSurvey, props<{ surveyId: string }>());
export const ApproveSurveySuccess = createAction(
    HwpActionTypes.ApproveSurveySuccess,
    props<{ survey: HealthyWorkplaceSurveyManagementDTO }>()
);
export const ApproveSurveyFailure = createAction(HwpActionTypes.ApproveSurveyFailure, props<{ error: any }>());

export const RejectSurvey = createAction(HwpActionTypes.RejectSurvey, props<{ surveyId: string }>());
export const RejectSurveySuccess = createAction(
    HwpActionTypes.RejectSurveySuccess,
    props<{ survey: HealthyWorkplaceSurveyManagementDTO }>()
);
export const RejectSurveyFailure = createAction(HwpActionTypes.RejectSurveyFailure, props<{ error: any }>());

export const AddSurveyUrl = createAction(HwpActionTypes.AddSurveyUrl, props<{ surveyId: string; newUrl: string }>());
export const AddSurveyUrlSuccess = createAction(
    HwpActionTypes.AddSurveyUrlSuccess,
    props<{ survey: HealthyWorkplaceSurveyManagementDTO }>()
);
export const AddSurveyUrlFailure = createAction(HwpActionTypes.AddSurveyUrlFailure, props<{ error: any }>());

export const CompleteSurvey = createAction(
    HwpActionTypes.CompleteSurvey,
    props<{
        surveyId: string;
        reportIds: string[];
    }>()
);
export const CompleteSurveySuccess = createAction(
    HwpActionTypes.CompleteSurveySuccess,
    props<{ survey: HealthyWorkplaceSurveyManagementDTO }>()
);
export const CompleteSurveyFailure = createAction(HwpActionTypes.CompleteSurveyFailure, props<{ error: any }>());

export const LoadSurveyDescription = createAction(HwpActionTypes.LoadSurveyDescription, props<{ surveyId: string }>());
export const LoadSurveyDescriptionSuccess = createAction(
    HwpActionTypes.LoadSurveyDescriptionSuccess,
    props<{
        surveyDescription: Blob;
    }>()
);
export const LoadSurveyDescriptionFailure = createAction(
    HwpActionTypes.LoadSurveyDescriptionFailure,
    props<{
        error: any;
    }>()
);
